import { CONECTORES } from '@/pages/painel/lib/inteligencia';

const STATUS_LABEL: Record<string, { label: string; tone: string }> = {
  conectado: { label: 'Conectado', tone: 'bg-green-50 text-green-700 border-green-200' },
  aguardando: { label: 'Aguardando conexão', tone: 'bg-amber-50 text-amber-700 border-amber-200' },
  erro: { label: 'Erro', tone: 'bg-red-50 text-red-600 border-red-200' },
  nao_disponivel: { label: 'Aguardando conexão', tone: 'bg-gray-100 text-gray-500 border-gray-200' },
};

export default function Conectores() {
  return (
    <section className="bg-white rounded-2xl border border-gray-200 p-6">
      <h3 className="text-sm font-bold text-gray-900 mb-1">Canais / Integrações</h3>
      <p className="text-xs text-gray-500 mb-4">
        Integração oficial/autorizada apenas — nada de scraping ou automação por navegador. Nenhuma integração falsa.
      </p>

      <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-3">
        {CONECTORES.map((c) => {
          const st = STATUS_LABEL.nao_disponivel;
          return (
            <div key={c.key} className="border border-gray-100 rounded-xl p-4">
              <div className="flex items-center gap-2 mb-2">
                <div className="w-8 h-8 flex items-center justify-center bg-gray-100 text-gray-600 rounded-lg">
                  <i className={`${c.icon} text-base`}></i>
                </div>
                <p className="text-sm font-semibold text-gray-800">{c.label}</p>
              </div>
              <p className="text-xs text-gray-400 mb-3">{c.desc}</p>
              <span className={`inline-flex items-center gap-1.5 text-[11px] font-semibold rounded-full px-2.5 py-1 border ${st.tone}`}>
                <i className="ri-time-line"></i>
                {st.label}
              </span>
            </div>
          );
        })}
      </div>

      <div className="mt-4 bg-gray-50 rounded-xl p-4 text-xs text-gray-500 leading-relaxed">
        <i className="ri-information-line text-gray-400"></i>{' '}
        Quando um conector autorizado (WhatsApp Business API, Instagram Graph, Google Calendar) for conectado, ele passará a alimentar
        última interação, canal, sinais comerciais e sugestões de próxima ação — sempre sem envio automático de mensagens.
      </div>
    </section>
  );
}